<template>
  <div class="warp warp_enterprise" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat;'">
      <div class="txt_box">
        <div class="t1">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>


    <div class="modle_7">

      <div class="cm_title">

        <div class="t1" v-scroll-reveal>
          AWARDS WE HAVE RECEIVED
        </div>

        <div class="t2" v-scroll-reveal>
          获得奖项
        </div>

        <div class="t3" v-scroll-reveal>
          连续<strong>6年</strong>蝉联<span style="color: #C19475;">五星</span>级京牌代理认证
        </div>

      </div>


    </div>

    <div class="modle_12">

      <div class="modle_10 cle">
        <div class="item fl" v-scroll-reveal v-for="(item,index) in data.list[0].list" :key="index">
          <img :src="item.img1" />
        </div>
      </div>

      <div class="modle_11 cle">
        <el-row :gutter="20">
          <el-col :xs="24" v-scroll-reveal :sm="24" :md="12" :lg="8" v-for="(item,index) in data.list[1].list" :key="index">
            <div class="grid-content">
              <img :src="item.img1" />
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="modle_13 cle">

        <div class="item fl" v-scroll-reveal v-for="(item,index) in data.list[2].list" :key="index">
          <div class="grid-content">
            <div class="img img_box">
              <img :src="item.img1" />
            </div>
            <div class="t1">
              金触点·全球商业创新大奖
            </div>
            <div class="t2">
              Top Touch Festival
            </div>
          </div>
        </div>

      </div>

    </div>





  </div>
</template>

<script>
  import {
    postCasesAPI,
    postfwtfAPI,
    postfwjsAPI,
    posthornorAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        sle_int: 0, //下表
        data: null, //案例信息


      }
    },
    methods: {
      //获取案例信息
      getList() {
        var that = this;
        posthornorAPI().then(function(res) {
          console.log(res);
          that.data = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },

      // //精准投放
      // jingzhunGetList() {
      //   var that = this;
      //   postfwtfAPI().then(function(res) {
      //     console.log(res);
      //     that.fwdata = res.data.data;
      //   }).catch(function(err) {
      //     console.log(err);
      //   })
      // },
      // //服务案例
      // fuwuanliGetList() {
      //   var that = this;
      //   postfwjsAPI().then(function(res) {
      //     console.log(res);
      //     that.jzdata = res.data.data;
      //   }).catch(function(err) {
      //     console.log(err);
      //   })
      // },
    },
    mounted() {
      this.getList();
      // this.jingzhunGetList();
      // this.fuwuanliGetList();
    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }


  .modle_7 {
    margin: 0px 135px;
    margin-top: 160px;

    .cm_title {
      text-align: center;
      margin-bottom: 125px;

      .t1 {
        font-size: 93px;
        color: #000000;
        font-weight: bold;
        margin-bottom: 40px;
      }

      .t2 {
        font-size: 50px;
        color: #000000;
        letter-spacing: 15px;
      }

      .t3 {
        font-size: 72px;
        color: #000000;
        margin-top: 115px;

      }
    }

    .tabbar {
      text-align: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      margin-bottom: 130px;
      padding-bottom: 30px;
      margin-bottom: 100px;

      .it {
        font-size: 20px;
        color: #636363;
        margin: 0px 64px;
        cursor: pointer;
      }

      .it_on {
        font-weight: bold;
        color: #000000;
        font-size: 26px;
      }
    }
  }

  .masonry {
    column-count: 3;
    column-gap: 5px;

    .item {
      break-inside: avoid;
      box-sizing: border-box;
      border: 1px solid brown;
      margin-bottom: 7px;
      background-color: wheat;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 50px;
      font-weight: bold;
      color: brown;
    }
  }




  .warp_enterprise {
    padding-bottom: 80px;
  }

  .modle_12 {
    margin: 0px 160px;
  }

  .modle_10 {


    .item {
      float: left;
      width: 48%;
    }

    .item:nth-child(2n) {
      float: right;
    }
  }

  .modle_11 {
    margin-top: 160px;
  }

  .modle_13 {
    margin-top: 180px;

    .item {
      width: 31%;
      margin-right: 2%;
      text-align: left;
      margin-bottom: 95px;
      cursor: pointer;
    }


    .item:nth-child(4),
    .item:nth-child(9) {
      width: 64%;
    }

    .img {
      height: 470px;
      margin-bottom: 30px;
      overflow: hidden;
    }

    .t1 {
      font-size: 28px;
      color: #000000;
      margin-bottom: 10px;
    }

    .t2 {
      font-size: 20px;
      color: #000000;

    }
  }
</style>



// WEBPACK FOOTER //
// src/view/honor/honor.vue